var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BLACK_700, Card, Typography, isLastItem, getTestId, Avatar, useBreakpoint, isValidObject } from '@airtel/air-design-system';
import { getPriceBreakupWidgetStyles } from './PriceBreakupWidgetStyles';
import { PriceBreakupItem } from './components/price-breakup-item';
import { ButtonWidget } from '../button-widget';
import { Pressable, View } from 'react-native';
import { TEXT_TYPE } from '../info-summary-widget/InfoSummaryWidgetConstants';
import { OfferStripWidget } from '../offer-strip-widget';
export var PriceBreakupWidgetComponent = props => {
  var title = props.title,
    _props$list = props.list,
    list = _props$list === void 0 ? [] : _props$list,
    rowButtonsWidgetProps = props.rowButtonsWidgetProps,
    headerIconName = props.headerIconName,
    onHeaderIconPress = props.onHeaderIconPress,
    headerIconProps = props.headerIconProps,
    onUserAction = props.onUserAction,
    _props$useWrappedText = props.useWrappedText,
    useWrappedText = _props$useWrappedText === void 0 ? false : _props$useWrappedText,
    footerSection = props.footerSection,
    offerStripWidgetProps = props.offerStripWidgetProps,
    testID = props.testID,
    id = props.id,
    style = props.style,
    restProps = __rest(props, ["title", "list", "rowButtonsWidgetProps", "headerIconName", "onHeaderIconPress", "headerIconProps", "onUserAction", "useWrappedText", "footerSection", "offerStripWidgetProps", "testID", "id", "style"]);
  var priceBreakupWidgetStyles = getPriceBreakupWidgetStyles(props);
  var _useBreakpoint = useBreakpoint({
      allowMdAsLargeScreen: true,
      returnAsObject: true
    }),
    isSmallScreen = _useBreakpoint.isSmallScreen;
  var hasOfferStripWidget = isValidObject(offerStripWidgetProps);
  return (list === null || list === void 0 ? void 0 : list.length) > 0 && _jsxs(Card, Object.assign({}, restProps, getTestId(testID), {
    noHorizontalPadding: true,
    style: [style, hasOfferStripWidget && {
      paddingBottom: 0
    }]
  }, {
    children: [!!title && _jsxs(View, Object.assign({
      style: priceBreakupWidgetStyles.titleContainer
    }, {
      children: [_jsx(Typography, Object.assign({
        style: priceBreakupWidgetStyles.itemSpacing,
        text: title,
        type: isSmallScreen ? TEXT_TYPE.TITLE_SINGLE_LINE_LG : TEXT_TYPE.TITLE_SINGLE_LINE_XL,
        color: BLACK_700
      }, getTestId(testID, 'titleText'))), !!headerIconName && _jsx(Pressable, Object.assign({
        onPress: () => onHeaderIconPress && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
          id
        }, onHeaderIconPress), Object.assign({}, props)))
      }, getTestId(testID, 'titleTextPressable'), {
        children: _jsx(Avatar, Object.assign({
          iconName: headerIconName,
          noBgContainer: true,
          variant: "icon",
          iconProps: headerIconProps
        }, getTestId(testID, 'headerIconName')))
      }))]
    })), list === null || list === void 0 ? void 0 : list.map((item, index) => {
      return _jsx(PriceBreakupItem, Object.assign({
        onUserAction: onUserAction
      }, item, {
        useWrappedText: useWrappedText,
        testID: testID + '_priceBreakup_' + (index === null || index === void 0 ? void 0 : index.toString()),
        style: !isLastItem(list, index) && priceBreakupWidgetStyles.itemSpacing
      }), "price_breakup_" + index);
    }), !!rowButtonsWidgetProps && _jsx(View, Object.assign({
      style: priceBreakupWidgetStyles.buttonWidgetContainer
    }, {
      children: _jsx(ButtonWidget, Object.assign({}, getTestId(testID, 'rowButtonsWidget'), {
        onUserAction: onUserAction
      }, rowButtonsWidgetProps))
    })), isValidObject(footerSection) && _jsx(PriceBreakupItem, Object.assign({
      onUserAction: onUserAction,
      useWrappedText: useWrappedText,
      testID: testID + 'footerSection',
      style: priceBreakupWidgetStyles.footerSection
    }, footerSection)), hasOfferStripWidget && _jsx(OfferStripWidget, Object.assign({
      variant: "in-card"
    }, offerStripWidgetProps, {
      inCardContainerStyle: [offerStripWidgetProps === null || offerStripWidgetProps === void 0 ? void 0 : offerStripWidgetProps.style, priceBreakupWidgetStyles.offerStripWidget],
      onUserAction: onUserAction
    }))]
  }));
};
PriceBreakupWidgetComponent.genericRendererKey = 'AirPriceBreakupWidget';